export default [
  {
    path: "/wx_auth",
    name: "wx_auth",
    component: () => import("@/components/WechatAuth.vue"),
    meta: {
      index: 1
    }
  },
  {
    path: "/zsplus_auth",
    name: "zsplus_auth",
    component: () => import("@/components/ZsplusAuth.vue")
  },
  {
    path: "/empty",
    name: "empty",
    component: () => import("@/components/EnvEmpty.vue")
  }
]
